// TODO: Fix types and remove use of 'any' and boundary types
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { timeDay, timeMonth, timeWeek } from 'd3'
import { toPng } from 'html-to-image'
import moment from 'moment'

import { FilterData, GROUP_TYPE, indextypes, regions, states } from '../constants/Filter'
import { defaultColour, graphColours } from '../constants/Graph'
import { Index, IndexDetail } from '../store/StateObjects'

const getMonthCount = (startDate: Date, endDate: Date): number => {
  return Math.ceil(moment(endDate).endOf('month').diff(moment(startDate).startOf('month'), 'months', true))
}

const isSingleDate = (startDate: Date, endDate: Date): boolean => {
  return moment(startDate).isSame(endDate)
}

const initIndexDetail = {
  refi_index: 0,
  change_week: 0,
  change_month: 0,
  change_quarter: 0,
  change_year: 0,
}

const getIndexDetail = (type: string, d: Index): IndexDetail => {
  if (!d || !d.volume || !d.value) {
    return initIndexDetail
  }

  switch (type) {
    case 'VOLUME':
      return d.volume
    case 'VALUE':
      return d.value
    default:
      // eslint-disable-next-line no-console
      console.warn('index detail type is incorrect, returning volume')
      return d.volume
  }
}

const getLineGraphColor = (id?: string | null): string => {
  if (!id) {
    return defaultColour
  }

  for (let i = 0; i < graphColours.length; i++) {
    if (graphColours[i].id === id) {
      return graphColours[i].colour
    }
  }
  return defaultColour
}

const getXScaleDomain = (startDate: Date, endDate: Date): [Date, Date] => {
  // For single date entry add offsets on starta nd end for it to be displayed in the centre
  if (isSingleDate(startDate, endDate)) {
    const startRange = timeDay.offset(startDate, -1)
    const endRange = timeDay.offset(startDate, 1)
    return [startRange, endRange]
  }
  const monthCount = getMonthCount(startDate, endDate)
  const isSingleMonth = monthCount === 1
  return [(isSingleMonth ? timeWeek : timeMonth).floor(startDate), timeMonth.ceil(endDate)]
}

const getXAxisTickValues = (start: Date, end: Date): Date[] => {
  const getMonthIncrement = (months: number) => {
    if (months > 1 && months <= 12) {
      return 1
    }
    if (months > 12 && months <= 24) {
      return 2
    }
    return Math.floor(months / 12)
  }

  const monthCount = getMonthCount(start, end)
  const isSingleMonth = monthCount === 1
  const incrementAmount = isSingleMonth ? 7 : getMonthIncrement(monthCount)
  const incrementUnit = isSingleMonth ? 'days' : 'months'

  const startClone = moment(start)
  const dates: Date[] = []
  while (startClone.toDate() <= end) {
    dates.push(startClone.toDate())
    startClone.add(incrementAmount, incrementUnit)
  }
  return dates
}

const getXAxisTimeFormat = (single: boolean, isMobile: boolean): string => {
  if (single) {
    return isMobile ? '%d %b' : '%d %b %y'
  }
  return isMobile ? '%b' : '%b %y'
}

const getFilterData = (type: string): FilterData[] => {
  switch (type) {
    case GROUP_TYPE.INDEX_TYPE:
      return indextypes
    case GROUP_TYPE.REGION:
      return regions
    default:
      return states
  }
}

const getLabel = (id: string, d: Array<FilterData>): string => {
  for (let i = 0; i < d.length; i++) {
    if (d[i].value === id) {
      return d[i].label
    }
  }
  return ''
}

function capitalize(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
}

function downloadPNG(href: string, name: string): void {
  const link = document.createElement('a')
  link.target = '_blank'
  link.download = name
  // link.style.opacity = "0";
  document.body.append(link)
  link.href = href
  link.click()
  link.remove()
}

// Convert svg to Canvas
function convertToCanvas(elementId: string, fileName: string, width: number, height: number): void {
  const node = document.getElementById(elementId) as HTMLElement
  const domUrl = window.URL || window.webkitURL || window
  if (!domUrl) {
    throw new Error('browser does not support this')
  }
  toPng(node, {
    width,
    height,
  })
    .then((dataUrl) => {
      const img = new Image()
      img.src = dataUrl
      downloadPNG(dataUrl, `${fileName}.png`)
    })
    .catch((error) => {
      throw new Error(error)
    })
}

// Draw graph circle
const drawGraphCircle = (
  c: any,
  x: number,
  y: number,
  name: string,
  lineNo: number,
  key?: string,
  strokeC?: string,
  strokeW?: number,
  r?: number,
): void => {
  c.append('circle')
    .classed(name, true)
    .attr('r', r || 11.5)
    .attr('cx', x)
    .attr('cy', y)
    .attr('stroke', strokeC || '')
    .attr('stroke-width', strokeW || 0)
    .style('fill', getLineGraphColor(lineNo > 1 ? key || '' : ''))
}

// Draw vertical dotted line
const drawVertLine = (l: any, x: number, name: string, yAxis = 'y-axis'): void => {
  const firstTick = l.select(`.${yAxis} .tick:first-of-type`).attr('transform')
  const lastTick = l.select(`.${yAxis} .tick:last-of-type`).attr('transform')
  let y1 = lastTick.substring(12, lastTick.length - 1)
  y1 = y1 < 0 ? 15 : y1
  let y2 = firstTick.substring(12, firstTick.length - 1)
  y2 = y2 < 0 ? 15 : y2

  l.append('line')
    .classed(name, true)
    .attr('stroke-dasharray', 2)
    .style('stroke', '#4C4D68')
    .attr('x1', x)
    .attr('x2', x)
    .attr('y1', y1)
    .attr('y2', y2)
}
export {
  capitalize,
  convertToCanvas,
  downloadPNG,
  drawGraphCircle,
  drawVertLine,
  getFilterData,
  getIndexDetail,
  getLabel,
  getLineGraphColor,
  getMonthCount,
  getXAxisTickValues,
  getXAxisTimeFormat,
  getXScaleDomain,
  isSingleDate,
}
